//roles

import { apiClient } from '@/api/axios';

export interface Permission {
  screen: string;
  access: (
    | 'create'
    | 'read'
    | 'update'
    | 'delete'
    | 'approval'
    | 'low_approval'
    | 'high_approval'
  )[];
}

export interface RoleResponse {
  id: string;
  name: string;
  key: string;
  permissions: Permission[];
}
export interface RoleFormData {
  name: string;
  key: string;
  permissions: Permission[];
}

export const getRoles = async (): Promise<RoleResponse[]> => {
  try {
    const response = await apiClient.get<RoleResponse[]>('roles');
    return response.data;
  } catch (error) {
    console.error('Get profile error:', error);
    throw error;
  }
};

export const updateRole = async (id: string, role: RoleFormData) => {
  const response = await apiClient.patch(`roles/${id}`, role);
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};
